import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { SolarEnergyModel } from '../../../../../models/site.model';
import { PlantServiceService } from '../../../../../services/dashboard/solar/plant-service.service';
@Component({
  selector: 'app-solar-energy',
  templateUrl: './solar-energy.component.html',
  styleUrls: ['./solar-energy.component.scss']
})
export class SolarEnergyComponent implements OnInit, AfterViewInit {
  siteId: string;
  solarEnergy: SolarEnergyModel;
  icon = true;
  constructor(
    private plantService: PlantServiceService,
    private cd: ChangeDetectorRef
  ) {
    this.solarEnergy = new SolarEnergyModel();
  }

  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      this.siteId = solarConfig.siteId;
      self.plantService
        .getTotalSolarEnergyYieldTrend(this.siteId)
        .subscribe((data) => {
          this.solarEnergy = <SolarEnergyModel>data;
        });
    });
  }
  ngAfterViewInit() {
    // this.cd.detectChanges();
  }
  public click = () => {
    this.icon = !this.icon;
  };
}
